import { render } from "./CadastrarParceiro.vue?vue&type=template&id=b9709058&scoped=true"
import script from "./CadastrarParceiro.vue?vue&type=script&lang=js"
export * from "./CadastrarParceiro.vue?vue&type=script&lang=js"

import "./CadastrarParceiro.vue?vue&type=style&index=0&id=b9709058&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9709058"]])

export default __exports__